// all the constants needed
const Constants = {
    ACCOUNT_ADDED: 'ACCOUNT_ADDED',
    ACCOUNT_DELETED: 'ACCOUNT_DELETED',
    ACCOUNT_FILLING_END: 'ACCOUNT_FILLING_END',
    ACCOUNT_FILLING_GET_ACCOUNTS: 'ACCOUNT_FILLING_GET_ACCOUNTS',
    ACCOUNT_FILLING_GET_ALL_ARTICLE: 'ACCOUNT_FILLING_GET_ALL_ARTICLE',
    ACCOUNT_FILLING_START: 'ACCOUNT_FILLING_START',
    ACCOUNT_GET_END: 'ACCOUNT_GET_END',
    ACCOUNT_GET_START: 'ACCOUNT_GET_START',
    ACCOUNT_UPDATED: 'ACCOUNT_UPDATED',
    ACCOUNTS_GET_END: 'ACCOUNTS_GET_END',
    ACCOUNTS_GET_START: 'ACCOUNTS_GET_START',
    ALERT_CLOSE: 'ALERT_CLOSE',
    ALERT_OPEN: 'ALERT_OPEN',
    ATTRIBUTE_NAMES_GET_END: 'ATTRIBUTE_NAMES_GET_END',
    ATTRIBUTE_NAMES_GET_START: 'ATTRIBUTE_NAMES_GET_START',
    CATALOGS_GET_END: 'CATALOGS_GET_END',
    CATALOGS_GET_START: 'CATALOGS_GET_START',
    CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
    CONTROL_TOWER_CHANGE_STATUS: 'CONTROL_TOWER_CHANGE_STATUS',
    CONTROL_TOWER_GET_DATA: 'CONTROL_TOWER_GET_DATA',
    CONTROL_TOWER_GET_DATA_START: 'CONTROL_TOWER_GET_DATA_START',
    CONTROL_TOWER_GET_STATS: 'CONTROL_TOWER_GET_STATS',
    DEFAULT_SCRIPT: 'window.get_pageinfo = function(){\n}\n',
    DIFF_IMPORT_ITEMS_END: 'DIFF_IMPORT_ITEMS_END',
    DIFF_IMPORT_ITEMS_START: 'DIFF_IMPORT_ITEMS_START',
    EXEC_IMPORT_ADDITIONAL_DATAS_END: 'EXEC_IMPORT_ADDITIONAL_DATAS_END',
    EXEC_IMPORT_ADDITIONAL_DATAS_ERROR: 'EXEC_IMPORT_ADDITIONAL_DATAS_ERROR',
    EXEC_IMPORT_ADDITIONAL_DATAS_START: 'EXEC_IMPORT_ADDITIONAL_DATAS_START',
    EXEC_IMPORT_ITEMS_END: 'EXEC_IMPORT_ITEMS_END',
    EXEC_IMPORT_ITEMS_START: 'EXEC_IMPORT_ITEMS_START',
    INIT_RIGHTS: 'INIT_RIGHTS',
    LOGIN: 'LOGIN',
    LOGIN_END: 'LOGIN_END',
    LOGIN_START: 'LOGIN_START',
    LOGOUT: 'LOGOUT',
    PERFORMANCE_ADDED: 'PERFORMANCE_ADDED',
    PERFORMANCE_DELETED: 'PERFORMANCE_DELETED',
    PERFORMANCE_UPDATED: 'PERFORMANCE_UPDATED',
    PERFORMANCES_GET_END: 'PERFORMANCES_GET_END',
    PERFORMANCES_GET_START: 'PERFORMANCES_GET_START',
    PROXY_DOMAIN_DELETED: 'PROXY_DOMAIN_DELETED',
    PROXY_DOMAIN_UPDATED: 'PROXY_DOMAIN_UPDATED',
    PROXY_GET_DOMAINS_END: 'PROXY_GET_DOMAINS_END',
    PROXY_GET_DOMAINS_START: 'PROXY_GET_DOMAINS_START',
    SCRAPING_SCRIPT_CREATE: 'SCRAPING_SCRIPT_CREATE',
    SCRAPING_TEST_CREATE: 'SCRAPING_TEST_CREATE',
    SCRAPING_TEST_DELETE: 'SCRAPING_TEST_DELETE',
    SITE_ADDED: 'SITE_ADDED',
    SITE_DELETED: 'SITE_DELETED',
    SITE_GET_END: 'SITE_GET_END',
    SITE_GET_START: 'SITE_GET_START',
    SITE_UPDATED: 'SITE_UPDATED',
    SITES_GET_END: 'SITES_GET_END',
    SITES_GET_START: 'SITES_GET_START',
    USER_ACTIONS_GET_END: 'USER_ACTIONS_GET_END',
    USER_ACTIONS_GET_START: 'USER_ACTIONS_GET_START',
    USER_ACTIONS_GRAPH_GET_END: 'USER_ACTIONS_GRAPH_GET_END',
    USER_ACTIONS_GRAPH_GET_START: 'USER_ACTIONS_GRAPH_GET_START',
    USER_ACTIONS_NAMES_GET: 'USER_ACTIONS_NAMES_GET',
    USER_ADDED: 'USER_ADDED',
    USER_DELETED: 'USER_DELETED',
    USER_GET_END: 'USER_GET_END',
    USER_GET_START: 'USER_GET_START',
    USER_UPDATED: 'USER_UPDATED',
    USERS_GET_END: 'USERS_GET_END',
    USERS_GET_START: 'USERS_GET_START'
};

export default Constants;
